import React, { useEffect, useState } from "react";

import styles from "./ApprovedTransaction.module.css";

import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  GetOrdensById,
  UpdatePayment,
} from "../../../store/orden-store/orden-actions";
import { getTokenInfo } from "../../../utils/Guard";
import Loading from "../../../components/loading/Loading";

const ApprovedTransaction = () => {
  let update = true;
  let showPage = false;

  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const params = useParams();
  const navigate = useNavigate();

  const userInfo = getTokenInfo();
  const orden = useSelector((state) => state.orden.orden);
  const transacion = useSelector((state) => state.orden.transaction);
  const notification = useSelector((state) => state.ui.notification);
  const [amountDollar, setAmountDollar] = useState(0);
  const [amountRD, setAmountRD] = useState(0);
  const [count, setCount] = useState(0);

  const paymentInfo = {
    OrderNumber: searchParams.get("OrderNumber"),
    Amount: amountRD,
    AuthorizationCode: searchParams.get("AuthorizationCode"),
    DateTime: searchParams.get("DateTime"),
    ResponseCode: searchParams.get("ResponseCode"),
    IsoCode: searchParams.get("IsoCode"),
    ResponseMessage:
      searchParams.get("ResponseMessage") === "ERROR"
        ? "Declinada"
        : searchParams.get("ResponseMessage"),
    ErrorDescription: searchParams.get("ErrorDescription"),
    RRN: searchParams.get("RRN"),
    CustomOrderId: searchParams.get("OrderNumber"),
    CardNumber: searchParams.get("CardNumber").split("****")[1],
    AzulOrderId: searchParams.get("AzulOrderId"),
  };

  useEffect(() => {
    if (orden && (orden.id === undefined || orden.id === 0)) {
      dispatch(GetOrdensById(paymentInfo.OrderNumber, userInfo.Email));
      setCount(orden.quantityOfUsers);
    }
  }, [dispatch, orden, userInfo.Email, userInfo.OrdenId]);

  useEffect(() => {
    if (orden && orden.id !== undefined && orden.id !== 0) {
      if (
        orden.discount &&
        orden.discount.id !== undefined &&
        orden.discount.id !== 0 &&
        count > 0
      ) {
        let discount = 0;
        if (orden.discount.percentage) {
          discount =
            orden.conference.price *
            count *
            (orden.discount.discountPercentage / 100);
        }
        if (orden.discount.nominal) {
          discount = orden.discount.discountNominal * count;
        }
        const dollar = orden.conference.price * count;
        const rd = (dollar - discount) * orden.dollarRate;

        setAmountDollar(dollar - discount);
        setAmountRD(rd);
      } else {
        const dollar = orden.conference.price * count;
        const rd = dollar * orden.dollarRate;
        setAmountDollar(dollar);
        setAmountRD(rd);
      }
    }
  }, [orden, count]);

  useEffect(() => {
    if (orden && orden.id !== undefined && orden.id > 0 && update) {
      update = false;
      dispatch(UpdatePayment(paymentInfo.OrderNumber, userInfo.Email, paymentInfo));
      showPage = true;
    }
  }, [orden]);

  return (
    <>
      {notification !== null &&
        notification !== undefined &&
        notification.status !== null &&
        notification.status !== undefined &&
        (notification.status === "pending" ||
          notification.status === "warning") &&
        notification.title !== "Se ha realizado el pago" && (
          <>
            <Loading />
          </>
        )}
      {/* {showPage == true && ( */}
      <div style={{ marginTop: "12%", padding: "0% 10%", textAlign: "center" }}>
        <Card className={styles.cardMessage}>
          <div className={`pi pi-check-circle ${styles.checkCircleIcon}`}></div>
          <h1>Transacción aprobada</h1>
          <p>El pago ha sido realizado exitosamente</p>
          <Button
            onClick={() => (window.location.href = "/mycourses")}
            className={styles.button}
            label="Volver a mis cursos"
          />
        </Card>
      </div>
      {/* )} */}
    </>
  );
};

export default ApprovedTransaction;
